import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9vx4sf6cb2: FaireBrandEntity = {
  token: "b_9vx4sf6cb2",
  type: "brand",
  name: "Left Hand Book House",
  avatarUrl:
    "https://cdn.faire.com/fastly/cec8acbe7244816a4baa62f53454ea3714f0b2a76141bdd981e1b9b481cb1097.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2e49e1e8ec344ef60e366c34338b1fdab8d104517617aab265cd5a3ff060b84c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/cec8acbe7244816a4baa62f53454ea3714f0b2a76141bdd981e1b9b481cb1097.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2e49e1e8ec344ef60e366c34338b1fdab8d104517617aab265cd5a3ff060b84c.png",
  location: "Provo, UT, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 50,
  isInsider: true,
  description:
    "Modern parents want books that are beautiful and educational. At Left Hand Book House, we create board books that cater to customers who strive for a design focused and peaceful feeling home. We use simple images and text to help little ones get acquainted with the world around them while maintaining the high quality look and feel that parents want to provide for their children. Our premiere collection, Let’s Go Baby, focuses on on active sports and outdoor activities and is the perfect standalone gift or bundles beautifully with other products in your store.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:09.982Z",
    importedBy: "entity-db-cli",
  },
};
